import { AnyAction, applyMiddleware, compose, createStore } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { ReduxState } from '../types/reducers';
import rootReducer from '../reducers/rootReducer';
import createHelpers from '../store/createHelpers';

export default function initializeStore(initialState: ReduxState, helpersConfig) {
  let composeEnhancers = compose;
  const helpers = createHelpers(helpersConfig);

  if (
    process.env.ENV !== 'production' &&
    !(typeof window === 'undefined') &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }

  const enhancer = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(helpers) as ThunkMiddleware<ReduxState, AnyAction, typeof helpers>)
  );

  return createStore(rootReducer, initialState, enhancer);
}
